import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=ce5636ae"
import script from "./ProductFeatures.vue?vue&type=script&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProductFeatures.vue?vue&type=style&index=0&id=ce5636ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports